import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import classes from "./auth-service-tools594.js";
import { factory } from "./auth-service-tools248.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { UnstyledButton } from "./auth-service-tools258.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { getFontSize, getSize } from "./auth-service-tools185.js";
const defaultProps = {};
const varsResolver = createVarsResolver((_, _ref) => {
  let {
    size
  } = _ref;
  return {
    pickerControl: {
      "--dpc-fz": getFontSize(size),
      "--dpc-size": getSize(size, "dpc-size")
    }
  };
});
const PickerControl = factory((_props, ref) => {
  const props = useProps("PickerControl", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    firstInRange,
    lastInRange,
    inRange,
    __staticSelector,
    selected,
    disabled,
    ...others
  } = props;
  const getStyles = useStyles({
    name: __staticSelector || "PickerControl",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver,
    rootSelector: "pickerControl"
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(UnstyledButton, { ...getStyles("pickerControl"),
    ref,
    unstyled,
    "data-picker-control": true,
    "data-selected": selected && !disabled || void 0,
    "data-disabled": disabled || void 0,
    "data-in-range": inRange && !disabled && !selected || void 0,
    "data-first-in-range": firstInRange && !disabled || void 0,
    "data-last-in-range": lastInRange && !disabled || void 0,
    disabled,
    ...others
  });
});
PickerControl.classes = classes;
PickerControl.displayName = "@mantine/dates/PickerControl";
export { PickerControl };